<template>
    <!-- Page Content -->
    <div id="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="page-header">
                <i class="fa fa-tags" aria-hidden="true"></i> Rotinas
            </h1>
          </div>
          <!-- /.col-lg-12 -->
        </div>
        <!-- /.row -->
        <div class="row">
          <div class="pull-right">
            <a
              class="btn btn-default"
              @click="
                addButton.seeForm = !addButton.seeForm;
                routine = {};
              "
            >
              <span v-if="addButton.seeForm">
                <i class="fa fa-search fa-fw"></i>Buscar
              </span>
              <span v-else> <i class="fa fa-plus fa-fw"></i> Adicionar </span>
            </a>
            <br />
            <br />
            <br />
          </div>
  
          <div class="col-lg-12">
            <div class="panel panel-default" v-if="addButton.seeForm">
              <div class="panel-body">
                <form role="form" @submit.stop.prevent="validateForm">
                  <input v-model="routine.id" type="hidden" />
                  <div class="form-group">
                    <label>id</label>
                    <input v-model="routine.id" class="form-control" disabled />
                  </div>
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="check-ativ"
                      v-model="routine.enabled"
                      
                    />
                    <!-- :checked="routine.enabled" -->
                    <label class="form-check-label" for="check-ativ">
                      Ativo
                    </label>
                  </div>
                  <div class="form-group">
                    <label>Nome</label>
                    <input v-model="routine.name" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label>Descricao</label>
                    <input v-model="routine.description" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label>Atividade</label>
                    <div>
                      <select class="form-select" aria-label="Default select example" v-model="routine.activityId">
                      <option value="">Selecione uma atividade</option>
                      <option v-for="activity in activities" 
                      :value="activity.id"
                      v-bind:key="activity.id">{{ activity.name }}</option>
                    </select>
                    </div>
      
                  </div>

                  <p>&nbsp</p>
  
                  <button type="submit" class="btn btn-lg btn-block btn-info">
                    Salvar
                  </button>
                </form>
              </div>
            </div>
            <div v-else class="panel panel-default">
              <div class="panel-body">
                <form>
                  <div class="form-group">
                    <input
                      v-model="search"
                      class="form-control"
                      placeholder="Buscar..."
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div v-if="filtred.length">
            <div class="col-lg-4" v-for="routine in filtred" :key="routine.id">
              <div class="panel panel-default">
                <div class="panel-heading">                
                  <b
                    data-toggle="tooltip"
                    data-placement="top"
                    v-bind:title="routine.name"
                    >{{ routine.name.substring(0, 25) }}
                    <i
                      v-if="routine.enabled === true"
                      class="fa fa-check-circle-o fa-fw text-success"
                    ></i>
                    <i v-else class="fa fa-times fa-fw text-danger"></i>
                  </b>
                  <div class="pull-right">
                    <div class="btn-group btn-group-xs" role="group">
                      <a
                        @click.stop="edit(routine.id)"
                        class="btn btn-sm btn-primary"
                        ><i class="fa fa-pencil fa-fw"></i
                      ></a>
                      <a
                        @click="
                          showModal = 1;
                          show = routine.id;
                        "
                        class="btn btn-sm btn-danger"
                        ><i class="fa fa-trash fa-fw"></i
                      ></a>
                    </div>
                    <br />
                  </div>
                  <br />
                </div>
                <div class="panel-body">
                  <p>
                  {{ limitedDescription(routine.description) }}
                  </p>
                </div>
              </div>
              <Modal v-if="showModal === 1 && show === routine.id">
                <i
                  slot="close"
                  @click="
                    showModal = null;
                    yes = null;
                  "
                  >&times;</i
                >
                <h2 slot="header">
                  <i class="fa fa-times fa-fw"></i>Remover Rotina
                </h2>
                <div slot="body">
                  <h4>
                    Deseja realmente remover a rotina?
                    <strong>{{ routine.name }}?</strong>
                  </h4>
                </div>
                <div slot="footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="
                      yes = true;
                      showModal = null;
                    "
                    @click.stop="remove(routine.id)"
                  >
                    Confirmar
                  </button>
                  <button
                    class="btn btn-default"
                    @click="
                      yes = null;
                      showModal = null;
                    "
                  >
                    fechar
                  </button>
                </div>
              </Modal>
            </div>
          </div>
          <Modal v-if="showModal === 2">
            <i slot="close" @click="showModal = null">&times;</i>
            <h2 slot="header">
              <i class="fa fa-exclamation-circle fa-fw"></i>Cadastro de Rotina
            </h2>
            <div slot="body">
              <div
                class="alert alert-success alert-small"
              ><i class="fa fa-exclamation"></i>
                Rotina cadastrada com sucesso!
              </div>
            </div>
            <div slot="footer">
              <button class="btn btn-default" @click="showModal = null">
                Ok
              </button>
            </div>
          </Modal>
          <Modal v-if="showModal === 3">
            <i slot="close" @click="showModal = null">&times;</i>
            <h2 slot="header">
              <i class="fa fa-times fa-fw"></i>Exclusão de Rotina
            </h2>
            <div slot="body">
              <div
                class="alert alert-success alert-small"
              ><i class="fa fa-exclamation"></i>
                Rotina excluída com sucesso!
              </div>
            </div>
            <div slot="footer">
              <button class="btn btn-default" @click="showModal = null">
                Ok
              </button>
            </div>
          </Modal>

          <Modal v-if="showModal === 4">
            <i slot="close" @click="showModal = null">&times;</i>
            <h2 slot="header">
              <i class="fa fa-exclamation-circle fa-fw"></i>Atualização de Rotina
            </h2>
            <div slot="body">
              <div
                class="alert alert-success alert-small"
              ><i class="fa fa-exclamation"></i>
                Rotina atualizada com sucesso!
              </div>
            </div>
            <div slot="footer">
              <button class="btn btn-default" @click="showModal = null">
                Ok
              </button>
            </div>
          </Modal>
          <div v-else-if="!filtred.length">
            <div class="alert alert-info">
              <p>
                <i class="fa fa-exclamation fa-fw"></i>Nenhum registro foi
                encontrado
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </div>
  </template>
  
  <script>
  import string from "../../mixins/string";
  import Modal from "../../components/ui-elements/Modal.vue";
  
  export default {
    name: "Routines",
    inject: ["loading"],
    components: { Modal },
    data() {
      return {
        search: "",
        addButton: { seeForm: false },
        routine: {},
        routines: [],
        activities: [],
        show: null,
        yes: null,
        showModal: null,
        sector: {},
        sectors: [],
        
      };
    },
    mounted() {
      this.loading.value = true;
      this.$http
        .get("/routine")
        .then((response) => {
          this.routines = response.data;

          this.$http.get("/activity")
          .then((response) => {
            this.activities = response.data;
          })
        })
        .finally(() => {
          this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip();
          });
  
          setTimeout(() => (this.loading.value = false), 1000);
        });

    },
    methods: {

      send() {

        this.loading.value = true;
  
        if (this.routine.id) {
          this.$http
            .put(`/routine/${this.routine.id}`, this.routine)
            .then((response) => {
              this.routines = this.routines.filter(
                (item) => item.id != this.routine.id
              );
              this.routines.push(response.data);
              this.routine = {};
              this.addButton.seeForm = false;
              this.showModal = 4;
            })
            .catch((error) => {
              console.log(error);
            });
          setTimeout(() => (this.loading.value = false), 1000);
        } else {
          this.$http
            .post("/routine", this.routine)
            .then((response) => {
              this.routine = {};
              this.routines.push(response.data);
              this.addButton.seeForm = false;
              this.showModal = 2;
              setTimeout(() => (this.loading.value = false), 1000);
            })
            .catch((error) => {
              console.log(error);
            });
          setTimeout(() => (this.loading.value = false), 1000);
        }
      },
      edit(id) {
        this.loading.value = true;
        this.$http
          .get(`/routine/${id}`)
          .then((response) => {
            this.addButton.seeForm = true;
            this.routine
             = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
        setTimeout(() => (this.loading.value = false), 1000);
      },
      remove(id) {
        this.loading.value = true;
        const confirm = this.yes;
  
        if (confirm) {
          this.$http
            .delete(`/routine/${id}`)
            .then((response) => {
              this.routines = this.routines.filter((item) => item.id != id);
              this.showModal = 3;
            })
            .catch((error) => alert(error));
          setTimeout(() => (this.loading.value = false), 1000);
        }
        setTimeout(() => (this.loading.value = false), 1000);
      },
      removeItem(rule, index) {
        this.$http
          .delete(`rule/${rule.id}`)
          .then((response) => {})
          .catch((error) => console.log(error))
          .finally(() => {
            this.rules.splice(index, 1);
          });
      },
      
      limitedDescription(routineDescription) {
        return (routineDescription.length <= 30)? routineDescription : `${routineDescription.substring(0, 30)}...`;
      },

      validateForm() {

        if(! this.routine.name 
          || ! this.routine.description
          || ! this.routine.activityId
        ) {
            alert("Preencha todos os campos")
        }
        else{
          this.send()
        }

      },
    },
    computed: {
      filtred() {
        const search = this.search.toLowerCase().trim();
        let result = [];
  
        if (!search) {
          result = this.routines;
        }
  
        result = this.routines.filter(
          (a) => a.name.toLowerCase().indexOf(search) > -1
        );
  
        return result.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      },    
  
    },

  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/components/pages/Routines.vue